import { EllipsesLoader } from '@/common/components/EllipsesLoader.tsx'
import { cn } from '@/common/utilities.ts'
import { Card } from './Card.tsx'

export type LoadingCardProps = {
  title?: string
  className?: string
}
export default function LoadingCard({ title, className }: LoadingCardProps) {
  return (
    <div className="h-full w-full flex items-center justify-center">
      <Card
        className={cn(
          'divide-y-0 p-4 flex flex-col items-center justify-center min-h-60 min-w-80 space-y-6',
          className
        )}
      >
        <EllipsesLoader size="md" />
        <div className="text-gray-700 text-xl font-medium mt-3 flex flex-col items-center justify-center">
          {title}
        </div>
      </Card>
    </div>
    // <div className="p-4 flex flex-col items-center justify-center min-h-52 min-w-80">
    //   {isLoading && <EllipsesLoader size="md" />}
    //   <span className="text-gray-800 text-xl font-medium mt-3">{prompt}</span>
    // </div>
  )
}
